export interface Category {
  id: string;
  nameKey: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: "shoes",
    nameKey: "categories.shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A_single_pair_of_crisp_white_leather_sneakers_with_soft_beige_accents_standing_on_a_warm_honey_wooden_floor_near_a_potted_green_plant_warm_golden_hour_side_light_high_detail_editorial_product_photography_lifestyle_mood_fresh_and_inviting&width=600&height=600&seq=cat-shoes-v2&orientation=squarish",
  },
  {
    id: "hoodies",
    nameKey: "categories.hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Hoodies.html",
    image:
      "https://readdy.ai/api/search-image?query=An_oversized_sage_green_hoodie_sweater_hanging_on_a_wooden_hanger_against_a_soft_plaster_wall_with_a_small_dried_pampas_grass_in_a_ceramic_vase_below_soft_diffused_daylight_high_detail_editorial_product_photography_calm_scandinavian_aesthetic&width=600&height=600&seq=cat-hoodies-v2&orientation=squarish",
  },
  {
    id: "tshirts",
    nameKey: "categories.tshirts",
    url: "https://kaspreadsheet.com/search-913/name/T-Shirts.html",
    image:
      "https://readdy.ai/api/search-image?query=A_neat_stack_of_folded_cream_white_and_blush_cotton_t_shirts_arranged_on_a_light_wooden_shelf_next_to_a_small_woven_basket_soft_warm_morning_light_high_detail_editorial_product_photography_cozy_retail_boutique_atmosphere&width=600&height=600&seq=cat-tshirts-v2&orientation=squarish",
  },
  {
    id: "jackets",
    nameKey: "categories.jackets",
    url: "https://kaspreadsheet.com/search-914/name/Jackets.html",
    image:
      "https://readdy.ai/api/search-image?query=A_stylish_tan_canvas_jacket_hanging_on_a_black_metal_rail_in_a_bright_minimal_wardrobe_with_a_soft_grey_wall_and_a_small_round_mirror_soft_cool_natural_light_high_detail_editorial_product_photography_clean_modern_apparel_store_style&width=600&height=600&seq=cat-jackets-v2&orientation=squarish",
  },
  {
    id: "pants",
    nameKey: "categories.pants",
    url: "https://kaspreadsheet.com/search-915/name/Pants.html",
    image:
      "https://readdy.ai/api/search-image?query=A_pair_of_neatly_folded_light_wash_denim_jeans_and_khaki_chinos_stacked_on_a_stone_grey_linen_bench_with_a_small_green_succulent_soft_even_natural_light_high_detail_editorial_product_photography_fresh_minimal_lifestyle_composition&width=600&height=600&seq=cat-pants-v2&orientation=squarish",
  },
  {
    id: "headwear",
    nameKey: "categories.headwear",
    url: "https://kaspreadsheet.com/search-916/name/Headwear.html",
    image:
      "https://readdy.ai/api/search-image?query=A_simple_olive_green_baseball_cap_and_a_soft_beige_beanie_placed_on_a_rust_terracotta_clay_surface_with_warm_side_light_casting_soft_shadows_high_detail_editorial_product_photography_earthy_warm_minimal_aesthetic&width=600&height=600&seq=cat-headwear-v2&orientation=squarish",
  },
  {
    id: "sets",
    nameKey: "categories.sets",
    url: "https://kaspreadsheet.com/search-917/name/Sets.html",
    image:
      "https://readdy.ai/api/search-image?query=A_matching_coordinated_loungewear_set_with_a_hoodie_and_joggers_flat_laid_on_a_blush_pink_textile_background_with_soft_top_down_lighting_and_a_few_eucalyptus_leaves_high_detail_editorial_product_photography_soft_feminine_fresh_mood&width=600&height=600&seq=cat-sets-v2&orientation=squarish",
  },
  {
    id: "underwear",
    nameKey: "categories.underwear",
    url: "https://kaspreadsheet.com/search-918/name/Underwear.html",
    image:
      "https://readdy.ai/api/search-image?query=A_folded_set_of_soft_white_and_heather_grey_cotton_underwear_arranged_in_a_ceramic_tray_on_a_powder_blue_background_with_soft_diffused_light_high_detail_editorial_product_photography_gentle_clean_and_hygienic_fresh_aesthetic&width=600&height=600&seq=cat-underwear-v2&orientation=squarish",
  },
  {
    id: "jersey",
    nameKey: "categories.jersey",
    url: "https://kaspreadsheet.com/search-919/name/Jersey.html",
    image:
      "https://readdy.ai/api/search-image?query=A_modern_mesh_sports_jersey_in_deep_forest_green_draped_over_a_dark_wooden_stool_against_a_soft_grey_studio_wall_with_a_single_small_gym_towel_soft_directional_light_high_detail_editorial_product_photography_sporty_clean_aesthetic&width=600&height=600&seq=cat-jersey-v2&orientation=squarish",
  },
  {
    id: "accessories",
    nameKey: "categories.accessories",
    url: "https://kaspreadsheet.com/search-920/name/Accessories.html",
    image:
      "https://readdy.ai/api/search-image?query=A_minimal_watch_a_pair_of_sunglasses_and_a_leather_card_holder_arranged_on_a_warm_caramel_leather_surface_with_soft_natural_window_light_high_detail_editorial_product_photography_premium_organized_lifestyle_composition&width=600&height=600&seq=cat-accessories-v2&orientation=squarish",
  },
  {
    id: "bags",
    nameKey: "categories.bags",
    url: "https://kaspreadsheet.com/search-921/name/Bags.html",
    image:
      "https://readdy.ai/api/search-image?query=A_tan_leather_crossbody_bag_and_a_canvas_tote_leaning_against_a_cream_painted_brick_wall_on_a_light_wooden_floor_with_soft_natural_light_high_detail_editorial_product_photography_effortless_urban_fresh_aesthetic&width=600&height=600&seq=cat-bags-v2&orientation=squarish",
  },
  {
    id: "belts",
    nameKey: "categories.belts",
    url: "https://kaspreadsheet.com/search-922/name/Belts.html",
    image:
      "https://readdy.ai/api/search-image?query=Three_rolled_genuine_look_leather_belts_in_tan_brown_and_black_with_brass_buckles_arranged_in_a_row_on_a_soft_olive_green_textile_background_with_soft_overhead_light_high_detail_editorial_product_photography_classic_refined_minimal_aesthetic&width=600&height=600&seq=cat-belts-v2&orientation=squarish",
  },
  {
    id: "perfumes",
    nameKey: "categories.perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Perfumes.html",
    image:
      "https://readdy.ai/api/search-image?query=An_elegant_amber_glass_perfume_bottle_with_a_minimal_label_standing_on_a_round_travertine_stone_pedestal_against_a_warm_sand_background_with_a_single_dried_flower_stem_soft_dramatic_light_high_detail_editorial_product_photography_luxurious_fresh_aesthetic&width=600&height=600&seq=cat-perfumes-v2&orientation=squarish",
  },
  {
    id: "other",
    nameKey: "categories.other",
    url: "https://kaspreadsheet.com/search-924/name/Other.html",
    image:
      "https://readdy.ai/api/search-image?query=A_curated_flat_lay_of_lifestyle_items_including_a_notebook_sunglasses_a_small_candle_and_a_watch_on_a_soft_mint_green_background_with_soft_top_down_light_high_detail_editorial_product_photography_playful_organized_fresh_aesthetic&width=600&height=600&seq=cat-other-v2&orientation=squarish",
  },
];

export const mainSiteUrl = "https://kaspreadsheet.com";